import { all } from "redux-saga/effects";
import homeRoot from "./home.saga";

/**
 * Permet d'initialiser les différents générateur de redux-saga.
 * différent démarrage sont possibles:
 * - takeLatest pour debounce
 * - takeEvery pour récupérer à chaque appel
 * - throttle pour limiter le nombre d'appel
 */
export default function* rootSaga() {
  yield all([...homeRoot]);
}
